import type { Root } from 'mdast';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import { unified } from 'unified';
import { visit } from 'unist-util-visit';

const markdownParser = unified().use(remarkParse).use(remarkGfm);

/**
 * Blanks level-one headings (ATX and setext). The wiki view renders the page title as its heading
 * and hides content h1s (`prose-h1:hidden`), so dropping them keeps a single h1 for crawlers and
 * screen readers without changing what readers see. Parsing preserves `#` lines in code and HTML
 * blocks; each removed heading leaves its line breaks so surrounding blocks do not merge.
 */
export function removeMarkdownTitleHeadings(markdown: string): string {
  const tree: Root = markdownParser.parse(markdown);
  let result = '';
  let cursor = 0;
  visit(tree, 'heading', (heading) => {
    const start = heading.position?.start.offset;
    const end = heading.position?.end.offset;
    if (heading.depth !== 1 || start === undefined || end === undefined) {
      return;
    }
    // Keep the line breaks so the blocks around the heading stay separate.
    result += markdown.slice(cursor, start) + markdown.slice(start, end).replace(/[^\n]/g, '');
    cursor = end;
  });
  return result + markdown.slice(cursor);
}
